import { DialogBody, Table, Button, Stack, Spinner } from "@chakra-ui/react";
import { UI } from "components";
import useAdhesionDistributors from "hooks/useAdhesionDistributors";
import { useState } from "react";

export default function Distributors({ selected, onChange = () => {}, ...props }){

    const [ term, setTerm ] = useState()
    const distributors = useAdhesionDistributors(term)

    return(
    <UI.Dialog title="Selecionar núcleo" {...props}>
        <DialogBody>

            <Stack gap={4}>
                <UI.Searchable autoFocus placeholder="Pesquisar pelo nome do núcleo..." onChange={setTerm} value={term} />

                <UI.Show visible={distributors.isFetching}>
                    <UI.Alert size="sm" indicator={<Spinner />}>Buscando núcleos...</UI.Alert>
                </UI.Show>

                <Table.Root size="sm" mt={4}>
                    <Table.Header>
                        <Table.Row>
                            <Table.ColumnHeader>Núcleo</Table.ColumnHeader>
                            <Table.ColumnHeader></Table.ColumnHeader>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        { distributors.data?.data?.map(item => {
                            const is_selected = selected === item.id
                            return(
                            <Table.Row key={item.id}>
                                <Table.Cell>{item.name}</Table.Cell>
                                <Table.Cell><Button size="xs" colorPalette="orange" variant={is_selected ? 'outline' : 'solid'} disabled={is_selected} onClick={() => onChange(item)}>{ is_selected ? 'Selecionado' : 'Selecionar'}</Button></Table.Cell>
                            </Table.Row>
                            )
                        }) }
                        
                    </Table.Body>
                </Table.Root>
            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}